/** A importação dos eixos da frota por CSV (14/10/2026). Sem `commit` é prévia. */
import { http } from '../../core/api/client'

export interface RelatorioEixos {
  commit: boolean
  linhas: number
  alteradas: number
  iguais: number
  casadas: {
    linha: number
    placa: string
    placa_cadastro: string | null
    antes: number | null
    depois: number
    levantaveis_antes?: number | null
    levantaveis_depois?: number | null
  }[]
  sem_cadastro: { linha: number; placa: string }[]
  ambiguas: { linha: number; placa: string; frotas: number }[]
  invalidas: { linha: number; placa: string; motivo: string }[]
  repetidas: { placa: string; linhas: number[]; eixos: number[] }[]
}

export async function enviarEixos(arquivo: File, commit: boolean): Promise<RelatorioEixos> {
  const corpo = new FormData()
  corpo.append('arquivo', arquivo)
  return http.post<RelatorioEixos>(`/fleet/eixos/importar${commit ? '?commit=1' : ''}`, corpo, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
